import { uiLocale } from '@/i18n'

/**
 * Метки времени сервера. Бэк отдаёт в ОДНОЙ ленте два формата, и это не
 * небрежность фронта, а устройство источников: события джобы пишутся
 * питоновским `datetime.now(UTC).isoformat()` и несут смещение
 * (`…+00:00`), а поля гейта читаются из колонки `timestamp without time
 * zone` и зоны не несут вовсе (`2026-09-18T10:00:00.123456`).
 *
 * По спецификации ECMAScript строка без смещения разбирается как ЛОКАЛЬНОЕ
 * время. Голый `new Date` на полях гейта увёл бы срок ответа на часовой
 * пояс автора — в Тбилиси это четыре часа, то есть «ещё есть время» у уже
 * закрытого вопроса. Значения без зоны фактически UTC: таймзона сессии
 * Postgres запинена, и время ответа пишется со срезанным tzinfo.
 *
 * Единственное место, которое об этом знает. И читатели ленты, и карточка
 * вопроса, и итог прогона ходят сюда.
 */

/** Есть ли у части после `T` явная зона: `Z`, `+03:00`, `-0400`. */
const hasZone = (value: string): boolean => {
  const time = value.slice(value.indexOf('T') + 1)
  return /[Zz]$/.test(time) || /[+-]\d{2}:?\d{2}$/.test(time)
}

export const serverTimeMs = (value: string | null | undefined): number | null => {
  if (!value) return null
  const ms = Date.parse(hasZone(value) ? value : `${value}Z`)
  return Number.isNaN(ms) ? null : ms
}

/** Показ автору его местным временем. `null` — метку разобрать не удалось;
 *  вызывающий обязан решить сам, что печатать вместо неё (пустая строка в
 *  UI лучше, чем «Invalid Date»). */
export const formatServerTime = (value: string | null | undefined): string | null => {
  const ms = serverTimeMs(value)
  return ms === null ? null : new Date(ms).toLocaleString(uiLocale())
}
